import classNames from "classnames";
import {common as stringsCommon, home as strings} from "strings";

import Button from "components/Button";
import PageTitle from "components/PageTitle";

import {useCurrentPharmacy} from "lib/useCurrentPharmacy";

import styles from "./HomePage.module.css";

const TERMS_AND_CONDITIONS_URL = "https://rx365.com/terms.html";

export default function HomePage() {
  const [pharmacy] = useCurrentPharmacy();
  const isDisabled = pharmacy?.rx365Enabled === false;

  return (
    <div className={styles.container}>
      <div className={classNames(styles.section, styles.infoSection)}>
        <div className={styles.textContainer}>
          <PageTitle>{strings.title}</PageTitle>
        </div>
        {isDisabled ? (
          <div className={styles.disabledText}>{strings.disabled}</div>
        ) : null}
        <div className={styles.buttonContainer}>
          {isDisabled ? null : (
            <>
              <Button to="/login">{stringsCommon.login}</Button>
              <Button
                className={styles.registerButton}
                to="/register"
                variant="unfilled"
              >
                {stringsCommon.register}
              </Button>
              <Button to="/pharmacy" variant="minimal">
                {strings.guest}
              </Button>
            </>
          )}
          <Button
            className={styles.termsAndConditions}
            labelClassName={styles.termsAndConditionsLabel}
            href={TERMS_AND_CONDITIONS_URL}
            variant="minimal"
          >
            {strings.termsAndConditions}
          </Button>
        </div>
      </div>
      <div className={classNames(styles.section, styles.imgSection)}>
        <img
          src="/pillbottle.svg"
          alt={strings.pillBottle}
          className={styles.img}
        />
      </div>
    </div>
  );
}
